import baseHttp from './baseHttp';

export const getDashboardStats = (restaurantId, startDate, endDate) =>
  baseHttp.get(`/api/kpi/restaurant/dashboard/${restaurantId}`, {
    params: { start_date: startDate, end_date: endDate, refresh: true },
  }).then((r) => r.data);

export const getPerformance = (restaurantId, startDate, endDate) =>
  baseHttp.get(`/api/kpi/restaurant/performance/${restaurantId}`, {
    params: { start_date: startDate, end_date: endDate },
  }).then((r) => r.data);

export const getMenuAnalytics = (restaurantId, startDate, endDate) =>
  baseHttp.get(`/api/kpi/restaurant/menu-analytics/${restaurantId}`, {
    params: { start_date: startDate, end_date: endDate },
  }).then((r) => r.data);
